import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { userAllocationService } from "../../services";
import { DataView, DataViewLayoutOptions } from "primereact/dataview";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import properties from "../../config/environmentProperties";
import { SelectButton } from "primereact/selectbutton";
import { Column } from "primereact/column";
import { toast } from "react-toastify";
import { capitalize } from "../../services/utility/helper";
import { Card } from "primereact/card";

function MyAction() {
  const [myActionList, setMyActionList] = useState({});
  const [layout, setLayout] = useState("grid");
  const [myActionTab, setMyActionTab] = useState("Timesheet");
  // const options = ["Timesheet", "Allocation"];

  let count = 0;

  useEffect(() => {
    if (count === 0) {
      count++;
      changeMyActionTab({ value: "Timesheet" });
    }
  }, []);

  const changeMyActionTab = (e) => {
    setMyActionTab(e.value);
    const tab = e.value;
    switch (tab) {
      case "Timesheet":
        userAllocationService.getMyAction().then((resp) => {
          var allTimesheet = [];
          var activeTimesheet = [];
          allTimesheet = resp.data.data.timesheet;
          allTimesheet.map((item) => {
            if (item !== null) {
              activeTimesheet.push(item);
            }
            return activeTimesheet;
          });
          try {
            setMyActionList(activeTimesheet);
          } catch (error) {
            // Error handle
          }
        });
        break;
      case "Allocation":
        userAllocationService.getMyAction().then((resp) => {
          var allAlloc = [];
          var activeAlloc = [];
          allAlloc = resp.data.data.allocation;
          allAlloc.map((item) => {
            if (item.Allocation !== null) {
              activeAlloc.push(item);
            }
            return activeAlloc;
          });
          try {
            setMyActionList(activeAlloc);
          } catch (error) {
            // Error handle
          }
        });
        break;
      //   case "Leaves":
      //     userAllocationService.getMyAction().then((resp) => {
      //       try {
      //         setMyActionList(resp.data.data.leaves);
      //       } catch (error) {
      //         // Error handle
      //       }
      //     });
      //     break;
      default:
        if (myActionTab === "Timesheet") setMyActionTab("Timesheet");
        else setMyActionTab("Allocation");
        break;
    }
  };

  /*ASK FOR APPROVAL API FOR ALLOCATION */

  const sendAllocReminder = (myActionList) => {
    var mgrName = JSON.parse(localStorage.user);
    const body = {
      id: myActionList.Allocation.id,
    };
    try {
      userAllocationService.updateAllocApprovalAction(body).then((resp) => {
        toast.success(
          "Reminder sent successfully to " +
          capitalize(
            mgrName.superior.firstName + " " + mgrName.superior.lastName
          )
        );
        setMyActionTab("Allocation");
      });
    } catch (error) {
      toast.error("Unable to send reminder");
    }
  };

  /*ASK FOR APPROVAL API FOR ALLOCATION */

  /*ASK FOR APPROVAL API FOR TIMESHEET */

  const sendTimesheetReminder = (myActionList) => {
    var mgrName = JSON.parse(localStorage.user);
    let body;
    body = {
      timesheetId: myActionList.id
    }
    try {
      userAllocationService
        .updateTimesheetApprovalAction(body)
        .then((resp) => {
          toast.success(
            "Reminder sent successfully to " +
            capitalize(
              mgrName.superior.firstName + " " + mgrName.superior.lastName
            )
          );
          setMyActionTab("Timesheet");
        });
    } catch (error) {
      toast.error("Unable to send reminder");
    }
  };

  /*ASK FOR APPROVAL API FOR TIMESHEET */

  /* DATA TABLE BODY TEMPLATES*/

  const dateBodyTemplate = (myActionList) => {
    return (
      <>{myActionList && <p>{myActionList.date}</p>}</>
    );
  };

  const startDateTemplate = (myActionList) => {
    return (
      <>
        {myActionList.Allocation && <p>{myActionList.Allocation.startDate}</p>}
      </>
    );
  };

  const endDateTemplate = (myActionList) => {
    return (
      <>{myActionList.Allocation && <p>{myActionList.Allocation.endDate}</p>}</>
    );
  };

  const statusBodyTemplate = () => {
    return (
      <>
        <span style={{ color: "orange" }}><strong>PENDING APPROVAL</strong></span>
      </>
    );
  };

  const actionBodyTemplate = (myActionList) => {
    return (
      <>
        {myActionList && (
          <Button
            className="p-button-rounded"
            label="Ask for Approval"
            style={{ width: "130px" }}
            onClick={() => sendTimesheetReminder(myActionList)}
          ></Button>
        )}
        {myActionList.Allocation && (
          <Button
            className="p-button-rounded"
            label="Ask for Approval"
            onClick={() => sendAllocReminder(myActionList)}
          ></Button>
        )}
      </>
    );
  };

  const projectBodyTemplate = (myActionList) => {
    return (
      <>
        {myActionList.Allocation && (
          <strong>{myActionList.Allocation.Project.title}</strong>
        )}
      </>
    );
  };

  /* DATA TABLE BODY TEMPLATES*/

  const renderHeader = () => {
    return (
      <div className="grid grid-nogutter">
        <div className={classNames(layout === "list" ? "col-6 mt-3 mb-3" : "col-6 mt-1")} style={layout === "list" ? { textAlign: "left", paddingLeft: "13px" } : { textAlign: "left" }}>
          <span style={{ fontSize: "18px" }}>My Actions</span>
          {/* <SelectButton
            value={myActionTab}
            options={options}
            onChange={(e) => changeMyActionTab(e)}
          /> */}
        </div>
        <div className={classNames(layout === "list" ? "col-6 mt-3 mb-3" : "col-6")} style={layout === "list" ? { textAlign: "right", paddingRight: "13px" } : { textAlign: "right" }}>
          <DataViewLayoutOptions layout={layout} onChange={(e) => setLayout(e.value)} />
        </div>
      </div>
    );
  };

  const header = renderHeader();

  const itemTemplate = (myActionList, layout) => {
    if (!myActionList) {
      return;
    }
    if (layout === "grid") return renderGridItem(myActionList);
  };

  const renderGridItem = (data) => {
    return (
      <div
        className={classNames("col-4", "ess-act-card", "ess-card-theam-1")}
        style={{ padding: "10px" }}
      >
        {data && (
          <div className="ess-act-body">
            <div className="container">
              <p>Pending Approval on timesheet by your manager</p>
              <div className="card-date">
                <div>
                  <strong>
                    {data.date ? data.date : ""}{" "}
                  </strong>
                </div>
              </div>{" "}
            </div>
            <div className="ess-act-footer">
              <div style={{ float: "left" }}></div>
              <div style={{ textAlign: "right" }}>
                <Button
                  label="Ask for Approval"
                  className="p-button-sm p-button-rounded"
                  onClick={() => sendTimesheetReminder(data)}
                />
              </div>
            </div>
          </div>
        )}

        {data.Allocation && (
          <div className="ess-act-body">
            <div className="container">
              <p>Upcoming Project</p>
              <p className="card-date">
                <div>
                  <strong>
                    {data.Allocation.projectId
                      ? data.Allocation.Project.title
                      : ""}{" "}
                  </strong>
                </div>
              </p>{" "}
            </div>
            <div className="ess-act-footer">
              <div style={{ float: "left" }}></div>
              <div style={{ textAlign: "right" }}>
                <Button
                  label="Ask for Approval"
                  className="p-button-sm p-button-rounded"
                  onClick={() => sendAllocReminder(data)}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="root">
      <div className="dataview-demo">
        <Card>
          {layout === "list" && myActionTab === "Timesheet" && (
            <DataTable paginator responsiveLayout="scroll"
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} rowsPerPageOptions={[10, 20, 50]}
              columnResizeMode="fit" scrollable="horizontal" value={myActionList} layout={layout} header={header}>
              <Column field="" header="Date" body={dateBodyTemplate} style={{ minWidth: "8rem" }}></Column>
              <Column field="" header="Status" body={statusBodyTemplate} style={{ minWidth: "8rem" }}></Column>
              <Column field="" header="Action" body={actionBodyTemplate} style={{ minWidth: "8rem" }}></Column>
            </DataTable>
          )}

          {layout === "list" && myActionTab === "Allocation" && (
            <DataTable paginator responsiveLayout="scroll"
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} rowsPerPageOptions={[10, 20, 50]}
              columnResizeMode="fit" scrollable="horizontal" value={myActionList} layout={layout} header={header}>
              <Column field="" header="Project" body={projectBodyTemplate}></Column>
              <Column field="" header="Start Date" body={startDateTemplate}></Column>
              <Column field="" header="End Date" body={endDateTemplate}></Column>
              <Column field="" header="Status" body={statusBodyTemplate}></Column>
              <Column field="" header="Action" body={actionBodyTemplate}></Column>
            </DataTable>
          )}

          {layout === "grid" && (
            <>
              <DataView paginator responsiveLayout="scroll" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} value={myActionList} layout={layout} header={header} itemTemplate={itemTemplate} />
            </>
          )}
        </Card>
      </div>
    </div>
  );
}

export default MyAction;